/*

FILE: elements.js
DESCRIPTION: Element refs for use in various modules
AUTHOR(S): R.J. LaCount

*/

const elements = {};
import { setInputStates } from './forms';

const setElementRefs = (context) => {
	const base = context || document;

	// Root-level elements
	elements.links = document.querySelectorAll('a');
	elements.loader = document.querySelector('#loader');
	elements.transitionBars = document.querySelector('#transition-bars');
	elements.barbaContainer = document.querySelector('.barba-container');
	elements.primaryNav = document.querySelector('.primary-nav');

	if (elements.primaryNav) {
		elements.mobileNavToggle = elements.primaryNav.querySelector('.mobile-nav-toggle');
		elements.primaryNavParents = elements.primaryNav.querySelectorAll('.primary-nav-link.has-children');
		elements.primaryNavChildren = elements.primaryNav.querySelectorAll('.primary-nav-child');

		elements.navTriggers = Array.from(elements.primaryNavParents).concat(Array.from(elements.primaryNavChildren));
	}

	// Page-level elements
	elements.animateIn = base.querySelectorAll('.animate-in');
	elements.headlineEntrance = base.querySelector('.headline-entrance');
	elements.accordions = base.querySelectorAll('.handorgel');
	elements.parallaxElements = base.querySelectorAll('.rellax');
	elements.splideCarousels = base.querySelectorAll('.splide');
	elements.carousels = base.querySelectorAll('.carousel');
	elements.formInputs = base.querySelectorAll('.freeform-input');
	elements.showTriggers = base.querySelectorAll('[data-trigger]');
	elements.showEls = base.querySelectorAll('[data-show]');
	elements.scrollTriggers = base.querySelectorAll('[data-scroll-to]');
	elements.loadMoreTriggers = base.querySelectorAll('.load-more-trigger');

	elements.bioModalTriggers = base.querySelectorAll('.bio-modal-trigger');
	elements.bioModal = base.querySelector('.bio-content-modal');
	elements.bioModalContent = base.querySelector('.bio-content-dest');
	elements.modalOverlay = base.querySelector('.modal-overlay');
	elements.modalOverlayClose = base.querySelector('.bio-content-modal');
	elements.modalClose = base.querySelectorAll('.modal-close');
	elements.videoEmbedsAlt = base.querySelectorAll('.video-embed-alt');
	elements.videoEmbeds = base.querySelectorAll('.video-embed');
	elements.videoBlocks = base.querySelectorAll('.video-block');

	// Set element-specific states
	if (elements.formInputs.length) setInputStates(elements.formInputs);
}

const wrapButtons = (btns) => {

	btns.forEach(btn => {
		const plusBtn = btn.classList.contains('plus-btn');

		// Create spans
		const textSpan = document.createElement('span');
		const arrowSpan = document.createElement('span');
		textSpan.classList.add('text');
		arrowSpan.classList.add(plusBtn ? 'plus' : 'arrow');

		// Wrap elements
		textSpan.appendChild(document.createTextNode(btn.firstChild.nodeValue));
		btn.replaceChild(textSpan, btn.firstChild);
		btn.appendChild(arrowSpan);
	});
}

const createSpeedLines = (wrappers) => {

	wrappers.forEach(wrapper => {
		const segments = wrapper.dataset.segments;
		const lines = wrapper.dataset.lines;

		for (let i = 0; i < lines; i++) {
			const line = document.createElement('div');
			line.classList.add('line');
			wrapper.appendChild(line);

			for (let ii = 0; ii < segments; ii++) {
				const segment = document.createElement('div');
				segment.classList.add('segment');
				line.appendChild(segment);
			}
		}
	});
}

export { elements, setElementRefs };
